"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TagPicker: function() {
        return _index.TagPicker;
    },
    renderTagPicker_unstable: function() {
        return _index.renderTagPicker_unstable;
    },
    useTagPicker_unstable: function() {
        return _index.useTagPicker_unstable;
    }
});
const _index = require("./components/TagPicker/index");
